import ApiService from '@/core/services/api.service';
import { normalizeIssuedPdfPayload } from '@/core/services/store/modules/einvoice/einvoice.adapter';

function mapPdfAxiosError(err) {
  const res = err?.response;
  const status = res?.status;
  const body = res?.data || {};
  const domain = body.data && typeof body.data === 'object' ? body.data : {};
  const code = domain.code || body.code;
  if (status === 503 && code === 'EINVOICE_PDF_NOT_READY') {
    const nextErr = new Error(body.message || 'PDF chưa sẵn sàng, hệ thống sẽ thử lại sau ít giây.');
    nextErr.code = 'EINVOICE_PDF_NOT_READY';
    nextErr.retryAfterSeconds = Number(domain.retryAfterSeconds) || 5;
    nextErr.isRetryable = domain.retryable !== false;
    return nextErr;
  }
  return err;
}

/**
 * @param {{ id: number, adjustmentInvoiceNo?: string, draftCode?: string }} draft
 */
export function buildAdjustmentDraftPdfViewerConfig(draft = {}) {
  const id = Number(draft?.id ?? draft?.draftId);
  const invoiceNo = draft.adjustmentInvoiceNo || draft.draftCode;
  const title = invoiceNo
    ? `Xem PDF hóa đơn điều chỉnh ${invoiceNo}`
    : `Xem PDF hóa đơn điều chỉnh #${id || ''}`.trim();
  const safeFileKey = String(invoiceNo || draft.draftCode || id || 'document').replace(/[^\w.-]+/g, '_');

  return {
    title: title || 'Xem PDF hóa đơn điều chỉnh',
    downloadName: `HDDT_DC_${safeFileKey}.pdf`,
    canDownload: true,
    canPrint: true,
    eventContext: {
      adjustmentDraftId: id || null,
      adjustmentInvoiceNo: draft.adjustmentInvoiceNo || null,
    },
    async loadPdf() {
      if (!Number.isFinite(id) || id < 1) {
        const e = new Error('Thiếu mã nháp điều chỉnh.');
        e.code = 'ADJUSTMENT_PDF_INVALID_CONTEXT';
        throw e;
      }
      try {
        const { data } = await ApiService.get(`v1/invoice-adjustment-drafts/${id}/pdf`);
        return normalizeIssuedPdfPayload(data);
      } catch (err) {
        throw mapPdfAxiosError(err);
      }
    },
  };
}
